/* eslint-disable no-underscore-dangle */
import { useEffect, useState } from "react";
import lod_ from "lodash";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import { LittleForm } from "components/Custom/LittleForm";
import FormActions from "redux-react/actions/formAction";
import { display } from "redux-react/reducers/snackBarReducer";
import { closeFormV2Dialog, getFormV2Dialogs } from "redux-react/reducers/applicationReducer";
import { createDictionarySkeleton } from "helpers/form";
import { formValidation } from "hooks/formHooks";
import i18n from "i18n";
import { getLabel } from "helpers/dictionary";
import { selectProfile } from "redux-react/reducers/profileReducer";
import { useResourceActions } from "hooks/useResourceActions";

const FormV2DialogItem = ({ dialog, index }) => {
	const {
		id,
		save: saveConfig = {},
		dictionary = {},
		resource = {},
		defaultValues = {},
		item = {},
		disabled = false,
		edit = false
	} = dialog;

	// Resource API
	const { insertResource, updateResource } = useResourceActions();

	const profile = useSelector(selectProfile);
	const dispatch = useDispatch();

	const [skeleton, setSkeleton] = useState(
		createDictionarySkeleton(dictionary?.items ?? {}, item || {})
	);
	const { valid } = formValidation(skeleton, dictionary);

	useEffect(() => {
		setSkeleton(createDictionarySkeleton(dictionary?.items ?? {}, item || {}));
	}, [dictionary, item]);

	const handleChange = (path, value) => {
		let clone = lod_.cloneDeep(skeleton);
		lod_.set(clone, path, value);
		setSkeleton(clone);
	};

	const closeDialog = () => {
		dispatch(closeFormV2Dialog({ id }));
	};

	const handleSaveAdd = () => {};

	const handleSave = () => {
		const updatedItem = lod_.merge({ _id: item?._id }, skeleton, defaultValues);
		const target = dialog?.target ?? resource?.storage?.collection;

		if (lod_.isNil(target)) {
			dispatch(
				display({
					message: i18n.t("FORMS.notSuccess"),
					type: "error"
				})
			);
			return;
		}

		const clonedID = lod_.cloneDeep(updatedItem._id);
		delete updatedItem._id;

		let data = {
			values: updatedItem,
			target
		};

		if (!lod_.isNil(saveConfig.actions)) {
			data.actions = saveConfig.actions;
		}

		if (!lod_.isNil(saveConfig.extra)) {
			data.extra = saveConfig.extra;
		}

		const onSuccess = res => {
			closeDialog();
			saveConfig.onSuccess?.(res, updatedItem, dialog);
		};

		const onFailure = err => {
			saveConfig.onFailure?.(err, dialog);
		};

		if (edit === true) {
			/**
			 * Edit
			 */
			if (lod_.isEmpty(resource)) {
				/**
				 * Update item with form API (old way)
				 */
				dispatch(FormActions.updateItem(clonedID, data, onSuccess, onFailure));
			} else {
				/**
				 * Update item with resource API
				 */
				updateResource(resource.code, clonedID, updatedItem, onSuccess);
			}
		} else if (lod_.isEmpty(resource)) {
			/**
			 * Create item with form API (old way)
			 */
			dispatch(FormActions.addItemEmpty(data, onSuccess, onFailure));
		} else {
			/**
			 * Create item with resource API
			 */
			insertResource(resource.code, updatedItem, onSuccess);
		}
	};

	const routeLabel = getLabel(dictionary?.label, profile?.language);

	return (
		<Dialog
			fullWidth
			maxWidth="md"
			open
			style={{
				zIndex: 1500 + index
			}}
			PaperProps={{
				style: {
					height: "90%",
					width: "100%",
					maxWidth: "90%"
				}
			}}
		>
			<DialogTitle>{`${edit ? i18n.t("FORMS.LABELS.update") : i18n.t("FORMS.LABELS.add")}${
				routeLabel ? ` ${routeLabel}` : ""
			}`}</DialogTitle>
			<DialogContent>
				<MDBox mt={2} bgColor="white" borderRadius="lg">
					<LittleForm
						object={dictionary?.items ?? {}}
						metadatasSkeleton={skeleton}
						handleChange={handleChange}
						disabled={disabled}
					/>
				</MDBox>
			</DialogContent>
			<DialogActions>
				{!disabled && (
					<MDButton variant="outlined" color="info" onClick={closeDialog}>
						{i18n.t("SETTINGS.cancel")}
					</MDButton>
				)}
				{!disabled && (
					<MDButton disabled={!valid} variant="contained" color="info" onClick={handleSave}>
						{edit ? i18n.t("SETTINGS.edit") : i18n.t("SETTINGS.add")}
					</MDButton>
				)}
				{disabled && (
					<MDButton variant="contained" color="info" onClick={() => closeDialog()}>
						{i18n.t("SETTINGS.close")}
					</MDButton>
				)}
			</DialogActions>
		</Dialog>
	);
};

const FormV2Dialogs = () => {
	const dialogs = useSelector(getFormV2Dialogs);

	if (lod_.isEmpty(dialogs)) {
		return null;
	}

	return dialogs.map((dialog, index) => (
		<FormV2DialogItem key={dialog.id ?? index} dialog={dialog} index={index} />
	));
};

export default FormV2Dialogs;
